
<template>
  <section>
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            お問い合わせ
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <b-field label="件名">
              <b-input v-model="title"></b-input>
            </b-field>
            <b-field label="内容">
              <textarea class="textarea main-message disp-scroll"
                v-model="content"
                placeholder="お問い合わせ内容を入力してください。">
              </textarea>
            </b-field>
            <b-field label="Email">
              <b-input type="email" v-model="email" maxlength="254"></b-input>
            </b-field>
            <b-field>
              <p>気軽にご意見、ご感想をお寄せください！！
                 サービスに関してのご質問や、良かった点、悪かった点、バグ報告や機能追加のリクエストなど
                 サービスを改善するために私たちにできることがありましたら、ぜひご連絡ください。</p>
            </b-field>
            <b-field position="is-centered" style="text-align: center !important;">
              <button class="button is-primary is-rounded" style="margin-top: 10px;" @click="sendRH()" :disabled="disabled" v-if="!disabled">送信する</button>
              <button class="button is-primary is-rounded" style="margin-top: 10px;" :disabled="disabled" v-if="disabled">送信する</button>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalRequestHelp',
  computed: {
    disabled () {
      return this.title === '' || this.content === '' || this.email === '' || this.email.indexOf('@') <= 0
    },
    ...mapState('auth', ['user', 'isModalRequestHelp'])
  },
  data () {
    return {
      isModal: false,
      isAuth: false,
      title: '',
      content: '',
      email: ''
    }
  },
  watch: {
    isModalRequestHelp: function () {
      this.isModal = this.isModalRequestHelp
    },
    isModal: function () {
      this.isModal ? console.log('isModal: true') : this.setRHModal()
    }
  },
  methods: {
    setRHModal () {
      console.debug('*** Start *** setRHModal')
      this.$store.dispatch('auth/setRHModal')
      console.debug('*** End *** setRHModal')
    },
    setAuthenticated () {
      console.debug('*** Start *** setAuthenticated')
      this.isAuth = true
      console.debug('*** End *** setAuthenticated')
    },
    sendRH () {
      console.debug('*** Start *** sendRH')
      console.log(process.env.reCAPTCHA_KEY + ' : ' + process.env.reCAPTCHA_SEC)
      this.$store.dispatch('auth/sendRH', {title: this.title, content: this.content, email: this.email})
      this.isModal = false
      this.title = ''
      this.content = ''
      this.email = ''
      this.sendedBar()
      console.debug('*** End *** sendRH')
    },
    sendedBar () {
      console.debug('*** Start *** sendedBar')
      this.$buefy.snackbar.open({
        message: 'お問い合わせ承りました！担当者が回答するまで今しばらくお待ちください。',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** sendedBar')
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalRequestHelp.vue